import { render, staticRenderFns } from "./ModalRazaoFallback.vue?vue&type=template&id=aed5e30e"
import script from "./ModalRazaoFallback.vue?vue&type=script&lang=js"
export * from "./ModalRazaoFallback.vue?vue&type=script&lang=js"
import style0 from "./ModalRazaoFallback.vue?vue&type=style&index=0&id=aed5e30e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports